module.exports = __webpack_public_path__ + "static/media/SMG_5StarKnockout.b20c8b31.png";